import { applyTextReplacements } from '../UniversalSearch/applyTextReplacements';
const pendingUndo = new WeakMap();
function moveFocusOutOfEditor(textarea, previousFocus) {
    textarea.setSelectionRange(0, 0);
    previousFocus.focus();
}
function handleUndoInput(event) {
    const textarea = event.currentTarget;
    const pending = pendingUndo.get(textarea);
    if (!pending || !(event instanceof InputEvent) || event.inputType !== 'historyUndo') {
        return;
    }
    if (!pending.isUndoSelection(textarea) || !pending.previousFocus.isConnected) {
        return;
    }
    pendingUndo.delete(textarea);
    // The browser restores the undone selection after this event, so it can only be cleared next frame.
    requestAnimationFrame(() => moveFocusOutOfEditor(textarea, pending.previousFocus));
}
function replaceSelection(textarea, start, end, text, isUndoSelection) {
    const previousFocus = document.activeElement;
    // Re-registering the same listener reference is a no-op, so no bookkeeping is needed.
    textarea.addEventListener('input', handleUndoInput);
    textarea.focus();
    textarea.setSelectionRange(start, end);
    const hasNativeUndoEntry = document.execCommand('insertText', false, text);
    if (!hasNativeUndoEntry) {
        textarea.value = textarea.value.slice(0, start) + text + textarea.value.slice(end);
    }
    if (!(previousFocus instanceof HTMLElement) || previousFocus === textarea || !previousFocus.isConnected) {
        return textarea.value;
    }
    if (hasNativeUndoEntry) {
        pendingUndo.set(textarea, { previousFocus, isUndoSelection });
    }
    moveFocusOutOfEditor(textarea, previousFocus);
    return textarea.value;
}
export function replaceTextRangeWithUndoSupport(textarea, start, end, replacement) {
    return replaceSelection(textarea, start, end, replacement, (target) => target.selectionStart === start && target.selectionEnd === end);
}
export function replaceAllTextRangesWithUndoSupport(textarea, ranges, replacement) {
    if (ranges.length < 1) {
        return textarea.value;
    }
    const nextText = applyTextReplacements(textarea.value, ranges, replacement);
    return replaceSelection(textarea, 0, textarea.value.length, nextText, (target) => target.selectionStart === 0 && target.selectionEnd === target.value.length && target.value.length > 0);
}
